import { useCallback, useEffect, useLayoutEffect, useRef, useState } from "react"

function useFixedDropdown(open, setOpenId) {
  const triggerRef = useRef(null)
  const dropRef = useRef(null)
  const rafRef = useRef(null)
  const [pos, setPos] = useState({ top: 0, left: 0, width: 0 })

  // position: fixed — координаты относительно вьюпорта, scrollY не нужен
  const calcPos = useCallback(() => {
    if (!triggerRef.current) return
    const r = triggerRef.current.getBoundingClientRect()
    const dropH = 240
    const spaceBelow = window.innerHeight - r.bottom
    const top = spaceBelow < dropH && r.top > dropH ? r.top - dropH - 4 : r.bottom + 4
    setPos({ top, left: r.left, width: r.width })
  }, [])

  // useLayoutEffect — позиция до первой отрисовки, без прыжка
  useLayoutEffect(() => {
    if (open) calcPos()
  }, [open, calcPos])

  // Обновляем при любом скролле / ресайзе пока открыто
  useEffect(() => {
    if (!open) return
    const onScroll = () => {
      if (rafRef.current) cancelAnimationFrame(rafRef.current)
      rafRef.current = requestAnimationFrame(calcPos)
    }
    window.addEventListener("scroll", onScroll, { passive: true, capture: true })
    window.addEventListener("resize", onScroll, { passive: true })
    return () => {
      window.removeEventListener("scroll", onScroll, true)
      window.removeEventListener("resize", onScroll)
      if (rafRef.current) cancelAnimationFrame(rafRef.current)
    }
  }, [open, calcPos])

  // Клик вне — закрываем
  useEffect(() => {
    if (!open) return
    const h = (e) => {
      if (triggerRef.current?.contains(e.target)) return
      if (dropRef.current?.contains(e.target)) return
      setOpenId(null)
    }
    document.addEventListener("mousedown", h)
    return () => document.removeEventListener("mousedown", h)
  }, [open, setOpenId])

  return { triggerRef, dropRef, pos }
}

export default useFixedDropdown
